var map = {
	"./1.png": "./src/assets/img/partner/1.png",
	"./10.png": "./src/assets/img/partner/10.png",
	"./11.png": "./src/assets/img/partner/11.png",
	"./12.png": "./src/assets/img/partner/12.png",
	"./13.png": "./src/assets/img/partner/13.png",
	"./14.png": "./src/assets/img/partner/14.png",
	"./15.png": "./src/assets/img/partner/15.png",
	"./16.png": "./src/assets/img/partner/16.png",
	"./17.png": "./src/assets/img/partner/17.png",
	"./18.png": "./src/assets/img/partner/18.png",
	"./19.png": "./src/assets/img/partner/19.png",
	"./2.png": "./src/assets/img/partner/2.png",
	"./20.png": "./src/assets/img/partner/20.png",
	"./21.png": "./src/assets/img/partner/21.png",
	"./22.png": "./src/assets/img/partner/22.png",
	"./23.png": "./src/assets/img/partner/23.png",
	"./24.png": "./src/assets/img/partner/24.png",
	"./25.png": "./src/assets/img/partner/25.png",
	"./26.png": "./src/assets/img/partner/26.png",
	"./27.png": "./src/assets/img/partner/27.png",
	"./28.png": "./src/assets/img/partner/28.png",
	"./29.png": "./src/assets/img/partner/29.png",
	"./3.png": "./src/assets/img/partner/3.png",
	"./30.png": "./src/assets/img/partner/30.png",
	"./31.png": "./src/assets/img/partner/31.png",
	"./32.png": "./src/assets/img/partner/32.png",
	"./33.png": "./src/assets/img/partner/33.png",
	"./34.png": "./src/assets/img/partner/34.png",
	"./35.png": "./src/assets/img/partner/35.png",
	"./36.png": "./src/assets/img/partner/36.png",
	"./4.png": "./src/assets/img/partner/4.png",
	"./5.png": "./src/assets/img/partner/5.png",
	"./6.png": "./src/assets/img/partner/6.png",
	"./7.png": "./src/assets/img/partner/7.png",
	"./8.png": "./src/assets/img/partner/8.png",
	"./9.png": "./src/assets/img/partner/9.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/partner sync recursive ^\\.\\/.*\\.png$";